export const promotionMapping: Record<string, string> = {
  PRIME_BIG_DEAL: 'Prime Big Deal',
  LIGHTNING_DEAL: 'Lightning Deal',
  LIMITED_TIME_DEAL: 'Limited Time Deal',
  PRIME_MEMBER: 'Prime Member',
  TOP_DEAL: 'Top Deal',
  PRIME_DAY_DEAL: 'Prime Day Deal',
  COUPON: 'Coupon',
  DEAL_OF_THE_DAY: 'Deal of the Day',
  BLACK_FRIDAY_DEAL: 'Black Friday Deal',
  EARLY_BLACK_FRIDAY_DEAL: 'Early Black Friday Deal',
  PRIME_SPRING_DEAL: 'Prime Spring Deal',
  BEST_DEAL: 'Best Deal',
  CYBER_MONDAY_DEAL: 'Cyber Monday Deal'
};
